import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { useApiQuery } from './useApiQuery';

const useGetAdminDashboardByDateTime = ({ currentdatetime, startdatetime, refetchInterval }) => {
  const trans = useSelector(translator);
  const dashboardApi = useSelector((state) => state.apis.dashboardApi);

  return useApiQuery(
    ['adminDashboardByDateTime', currentdatetime, startdatetime],
    () =>
      new Promise((resolve, reject) => {
        dashboardApi.getAdminDashboardByDateTime(
          currentdatetime,
          startdatetime,
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              resolve(data);
            },
            errorCallback: () => {
              reject([]);
            },
            failCallback: () => {
              reject([]);
            },
          })
        );
      }),
    { refetchInterval }
  );
};

export default useGetAdminDashboardByDateTime;
